import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTaggingInformationScreen } from '../../../../utils/Tagging';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import { FilterContainer, FormContainer } from './styles';
import { Title, TextField, Button, Icon, Select } from '@gerdau/hefesto';
import BilletTabContentTable from './BilletTabContentTable';
import { ICustomerBilletItem } from '../../../../store/ducks/download-area/types';
import { ApplicationState } from '../../../../store';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import { EInvoiceStatus } from '../../../../store/ducks/invoices/types';

const BilletTabContent: React.FC = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { screenName = '' } = getTaggingInformationScreen('download-area');
  const { itemDescription = '' } = getTaggingInformationScreen('2avia-boleto');

  const [billetsData, setBilletsData] = useState<ICustomerBilletItem[]>([]);
  const [filterStatus, setFilterStatus] = useState<EInvoiceStatus>(
    EInvoiceStatus.ALL
  );
  const [filterValue, setFilterValue] = useState('');

  const downloadAreaState = useSelector(
    (appState: ApplicationState) => appState.downloadArea
  );
  const billetState = useSelector(
    (appState: ApplicationState) => appState.downloadArea.billetsState
  );

  const isDisabled = downloadAreaState.billetsState.loading;

  useEffect(() => {
    dispatch(
      sendTagging({
        screenName: `${screenName}:2aViaDeBoleto`,
        page: pathname,
        event: 'page_view'
      })
    );
  }, []);

  useEffect(() => {
    setBilletsData(billetState.items);
  }, [billetState.items]);

  const onFilter = (status: EInvoiceStatus, value: string) => {
    setFilterStatus(status);
    setFilterValue(value);

    const filteredData: ICustomerBilletItem[] = billetState.items.filter(
      (billet: ICustomerBilletItem) =>
        billet.orderNumber.includes(value) ||
        billet.totalValue.toString().replaceAll('.', '').includes(value) ||
        (billet.billingDate &&
          moment(billet.billingDate, 'YYYY-MM-DD')
            .format('DD/MM/YYYY')
            .includes(value)) ||
        (billet.dueDate &&
          moment(billet.dueDate, 'YYYY-MM-DD')
            .format('DD/MM/YYYY')
            .includes(value))
    );

    if (status !== EInvoiceStatus.ALL) {
      const filteredDataByStatus = filteredData.filter(
        (billet: ICustomerBilletItem) => billet.status.includes(status)
      );

      return setBilletsData(filteredDataByStatus);
    }

    setBilletsData(filteredData);
  };

  const onClearFilter = () => {
    dispatch(
      sendTagging({
        screenName: `${screenName}:2aViaDeBoleto`,
        itemDescription: `${itemDescription}limparFiltros`,
        itemName: `button:limpar_filtros`,
        filterInfo: `#stt:[${filterStatus}]#ftt:[${filterValue}]`,
        event: 'click'
      })
    );

    setFilterStatus(EInvoiceStatus.ALL);
    setFilterValue('');
    setBilletsData(billetState.items);
  };

  return (
    <>
      <FilterContainer>
        <Title level={3}>Filtros</Title>
        <FormContainer>
          <div className="input-wrapper">
            <TextField
              label={'Pesquisar'}
              placeholder={
                'Número do pedido, valor total, faturamento ou vencimento'
              }
              name={'Search'}
              value={filterValue}
              onChange={(e) => onFilter(filterStatus, e.target.value)}
              icon={<Icon option={'Search'} />}
              iconPosition="left"
              type="search"
              disabled={isDisabled}
            />
          </div>
          <div className="input-status">
            <Select
              label={'Status'}
              disabled={isDisabled}
              name="statusSelect"
              options={Object.values(EInvoiceStatus)
                .filter((s) => s !== EInvoiceStatus.CLOSED)
                .map((s) => {
                  return {
                    label: s,
                    value: s
                  };
                })}
              value={filterStatus}
              onSelect={(e) => onFilter(e as EInvoiceStatus, filterValue)}
            />
          </div>
          <Button
            onClick={() => onClearFilter()}
            disabled={filterStatus === EInvoiceStatus.ALL && !filterValue}
            name={'cleanFilter'}
            variant="none"
          >
            Limpar filtros
          </Button>
        </FormContainer>
      </FilterContainer>
      {!isDisabled && <BilletTabContentTable data={billetsData} />}
    </>
  );
};

export default BilletTabContent;
